import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AgriSolutionState, RootState } from "../../Redux";
import { Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FmTransition } from "../FmTransition/FmTransition";

interface BoxData {
    color: string;
    text: string;
}

const boxData: BoxData[] = [
    {
        color: "#006543",
        text: ">30%",
    },
    {
        color: "#369946",
        text: "10 to 30%",
    },
    {
        color: "#FDEE21",
        text: "10 to -10%",
    },
    {
        color: "#F15A23",
        text: "-10 to -30%",
    },
    {
        color: "#C9252C",
        text: "< -30%",
    },
];

export const FmCarbonIndexDialog = () => {
    const isIndexOpen = useSelector((state: RootState) => state.agriSolution.releaseGraphState.isIndexDialogOpen);
    const dispatch = useDispatch();

    function dismissDialog() {
        dispatch(AgriSolutionState.Actions.toggleIndexDialog(false));
    }

    return (
        <Dialog
            open={isIndexOpen}
            TransitionComponent={FmTransition}
            keepMounted
            sx={{ top: "auto", bottom: 0 }}
            onClose={dismissDialog}
            PaperProps={{
                sx: {
                    borderRadius: "8px",
                },
            }}
        >
            <DialogTitle sx={{ padding: "24px 65px 0 65px" }}>INDEX (Multicote™ Technology Vs. Traditional application)</DialogTitle>

            <IconButton
                aria-label='close'
                onClick={dismissDialog}
                sx={{
                    position: "absolute",
                    right: 12,
                    top: 12,
                    width: 10,
                    height: 10,
                    color: "#000",
                }}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent sx={{ padding: "24px 65px" }}>
                <Stack direction={"row"} justifyContent={"space-between"} sx={{ marginBottom: "24px", minWidth: "45vw" }}>
                    {boxData.map((b) => {
                        return (
                            <Stack key={"index_" + b.color + "_" + b.text} alignItems={"center"} direction={"row"} gap='16px'>
                                <div style={{ backgroundColor: b.color, width: 40, height: 40 }}></div>
                                <div>{b.text}</div>
                            </Stack>
                        );
                    })}
                </Stack>

                <DialogContentText>* % Difference between fertigation and topsoil application</DialogContentText>
            </DialogContent>
        </Dialog>
    );
};
